/*global Mustache, search_GUID, fakeRedirect, selectedCar, offerNotFoundOrExpired, fcBanner, searchHash, viewedCars, filter, listData, dcUiDropDown,
    gaQuery, gaEvent, urlParser, isModification, LazyLoad, optimizeVariant281, tooltip, myCookie, myDataLayer, storage, carsPerPage,
    moreText, lessText, benefitsMaxShow, myModal, isAlternativeFlow, alternativeCar, promoBanner, abTest470, analyticEventTracker,
    grecaptcha, abTest485 */

var sp = {
    impressionViewDefaultBatch: 25,
    currentImpressionViews: 0,
    dataSnapshot: {},
    renderedProductBatch: [],
    trackPricesModalProps: {
        modalWindowClass: 'bg-black-04 default new',
        closeOutside: true,
        onlyClose: true,
        noHeader: true
    },
    init: function() {
        sp.action();
        sp.search.init();
        sp.shuffle();
        sp.sortBy();
        sp.checkLoadingFill();
    },
    showSearchSurvey: function() {
        const surveyShownCookie = myCookie.getCookie('dch-sss');
        const showSearchSurvey = $('#searchSurveyModal').length > 0;

        if (!surveyShownCookie && showSearchSurvey) {
            myCookie.setCookie('dch-sss', 1);
            myModal.staticModal('searchSurveyModal', {
                noHeader: true,
                onlyClose: true,
                closeOutside: true,
                modalBodyClass: 'h-750'
            });
        }
    },
    shuffle: function() {
        const suppliersCount = $('.suppliers-logo').length;
        const array = Array.from(Array(suppliersCount).keys());
        let currentIndex = array.length, temporaryValue, randomIndex;

        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        const delayArray = [];

        array.forEach(function() {
            var randomDelay = Math.floor(Math.random() * 1201) + 500;
            delayArray.push(randomDelay);
        });

        let i = 0;
        array.forEach(function() {
            sp.supplierLogoIsReady(i, array, delayArray);
            i++;
        });
    },
    supplierLogoIsReady: function(i, array, delayArray) {
        setTimeout(function() {
            $('#logo-' + array[i]).addClass('supplier-logo-ready');
        }, i * delayArray[i]);
    },
    action: function() {
        $('.leaflet-popup-button').on('click', function(e) {
            e.preventDefault();
            $('#hirepoints-map').hide();
        });

        $('.change-search').on('click', function(e) {
            e.preventDefault();
            var type = $(this).data('type');

            $('.change-mode.' + type).hide();
            $('.location-mode.' + type).show();
        });

        $(document).on('click', '.more-less a', function(e) {
            e.preventDefault();

            var that = $(this),
                more = that.data('more-text'),
                less = that.data('less-text');

            that.text((that.hasClass('less') ? more : less))
                .toggleClass('less')
                .parents('.free-extras')
                .find('.hide')
                .toggleClass('show');
        }).on('click', '.fc-heading', function() {
            $('.fc-full').slideToggle();
            $('.fc-box').toggleClass('opened');
        }).on('click', '.car-groups-item', function() {
            var that = $(this);

            if (that.hasClass('disabled') || that.hasClass('selected')) {
                return false;
            }

            $('.car-groups-item').removeClass('init');
            that.addClass('selected');

            if (!that.hasClass('triggered')) {
                $('#' + that.data('id')).trigger('click');
            }

        }).on('click', '.car-groups-remove', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var that = $(this);
            that.parent().removeClass('selected');
            if (!that.hasClass('triggered')) {
                $('#' + that.data('id')).trigger('click');
            }
            that.parent().removeClass('triggered');
            that.removeClass('triggered');
            filter.carGroupsUncheck('item');
            filter.formData();
        }).on('click', '.toggle-price-item', function() {
            $(this).toggleClass('opened').nextAll('.price-item-row').toggleClass('opened');
        }).on('mousedown', '.click-on-car', function(e) {
            e.preventDefault();
            $(this).parents('.car-box').addClass('viewed');

            let positionInList = $(this).parents('.car-box').prevAll('.car-box').not('.filtered-out').length + 1;
            let url = new URL($(this).attr('href'));
            url.searchParams.set('dc_pil', positionInList);

            $(this).attr('href', url.href);
            $(this).click();
        }).on('click', '.more-benefits', function(e) {
            e.preventDefault();
            e.stopPropagation();

            var that = $(this),
                more = that.data('more-text'),
                less = that.data('less-text');

            that.text((that.hasClass('less') ? more : less))
                .toggleClass('less')
                .parents('.car-box-benefits-wrapper')
                .find('.hide')
                .toggleClass('show');
        }).on('click', '.greatProtectionShowMore', function(e) {
            e.preventDefault();
            const that = $(this);

            that.toggle();
            that.parent().parent().parent().find('.greatProtectionList').removeClass('hide-important');
        }).on('click', '.upsell-carousel .bullets .bullet', function(e) {
            e.preventDefault();

            $('.upsell-carousel .navigation .bullet').removeClass('active');
            $(this).addClass('active');

            const index = $(this).index();
            sp.scrollUpsellCarousel(index);
        }).on('click', '.upsell-carousel .arrows .arrow', function(e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) {
                return;
            }

            const direction = $(this).hasClass('left') ? 'left' : 'right';
            sp.scrollUpsellCarousel(null, direction);
        }).on('change', '.track-prices .switch input', function(e) {
            e.preventDefault();

            if ($(this).is(':checked')) {
                myModal.openStaticModal('trackPricesModal', sp.trackPricesModalProps);

                const eventData = {
                    eventName: 'Price_Track_Initiated',
                    attributes: {
                        'attributePageSource': _d.page
                    }
                };

                analyticEventTracker.trackEvent(eventData);
            }
        }).on('click', '.track-prices-submit', function(e) {
            e.preventDefault();

            $('#track-prices-form').validate({
                errorClass: 'error',
                focusInvalid: false,
                errorElement: 'div',
                rules: {
                    track_prices_email: {
                        validate_email: true,
                        required: true
                    }
                },
                errorPlacement: function(error) {
                    $('#track-prices-email-error').html(error);
                },
                highlight: function(element) {
                    $(element).addClass('error');
                },
                unhighlight: function(element) {
                    $(element).removeClass('error');
                },
                invalidHandler: function() {
                    setTimeout(function() {
                        $('.track-prices-submit').removeClass('loading');
                    }, 10);
                },
                submitHandler: function() {
                    const emailInput = $('#track-prices-email');
                    emailInput.removeClass('error');

                    myModal.close('trackPricesModal');
                    $('.track-prices .switch input').prop('checked', false);

                    setTimeout(function() {
                        myModal.openStaticModal('trackPricesNotAvailableModal', sp.trackPricesModalProps);
                    }, 1000);

                    const eventData = {
                        eventName: 'Price_Track_Email_Submitted',
                        attributes: {
                            'attributePageSource': _d.page
                        }
                    };

                    analyticEventTracker.trackEvent(eventData);
                }
            });

            $('#track-prices-form').submit();
        }).on('click', '.track-prices-not-available-submit', function(e) {
            e.preventDefault();

            myModal.close('trackPricesNotAvailableModal');
        }).on('click', '.logo-search-parent .search-carousel .bullets .bullet', function(e) {
            e.preventDefault();

            const index = $(this).index();
            sp.scrollTopSearchCarousel(index);
        }).on('click', '.logo-search-parent .search-carousel .arrows .arrow', function(e) {
            e.preventDefault();

            if ($(this).hasClass('disabled')) { return; }

            const isLeft = $(this).hasClass('left');
            const currentIndex = $('.logo-search-parent .search-carousel .bullets .bullet.active').index();
            const newIndex = isLeft ? Math.max(0, currentIndex - 1) : Math.min(currentIndex + 1, 2);
            sp.scrollTopSearchCarousel(newIndex);
        });
    },
    checkLoadingFill: function() {
        const fill = $('.logo-search-parent .loading-box__fill');
        let progress = 0;
        let interval;

        interval = setInterval(function() {
            if (progress < 95) {
                progress += 1;
                fill.css('width', progress + '%');
            }

            if (!$('.content-wrap').hasClass('hide')) {
                clearInterval(interval);
                fill.animate({ width: '100%' }, 500);
            }
        }, 100);
    },
    scrollTopSearchCarousel: function(index) {
        const carousel = $('.logo-search-parent .search-carousel .items');
        const items = carousel.find('.item');
        const itemWidth = items.outerWidth(true);
        const scrollLeft = _d.isRTL ? -(index * itemWidth) : index * itemWidth;

        carousel.animate({ scrollLeft: scrollLeft }, 300);

        const bullets = $('.logo-search-parent .search-carousel .bullets .bullet');
        bullets.removeClass('active');
        bullets.eq(index).addClass('active');

        const leftArrow = $('.logo-search-parent .search-carousel .arrows .arrow.left');
        const rightArrow = $('.logo-search-parent .search-carousel .arrows .arrow.right');

        leftArrow.toggleClass('disabled', index === 0);
        rightArrow.toggleClass('disabled', index === items.length - 1);
    },
    scrollUpsellCarousel: function(index, direction = null) {
        const carousel = $('.upsell-carousel .upsell-items');
        const items = carousel.find('.upsell-item');
        const itemWidth = items.outerWidth(true);
        const totalItems = items.length;
        const visibleItems = Math.floor(carousel.width() / itemWidth);
        const navigation = $('.upsell-carousel .navigation');
        const bullets = navigation.find('.bullets .bullet');

        let newScrollLeft;

        if (direction) {
            const currentScrollLeft = carousel.scrollLeft();
            const maxScrollLeft = carousel[0].scrollWidth - carousel.width();

            if (direction === 'left') {
                newScrollLeft = Math.max(0, currentScrollLeft - (itemWidth + 16));
                if (currentScrollLeft <= (itemWidth + 16)) {
                    bullets.removeClass('active');
                    bullets.eq(0).addClass('active');
                    navigation.find('.arrow.left').addClass('disabled');
                    navigation.find('.arrow.right').removeClass('disabled');
                }

                if ((maxScrollLeft - currentScrollLeft) <= (itemWidth + 16)) {
                    bullets.removeClass('active');
                    bullets.eq(1).addClass('active');
                    navigation.find('.arrow.left').removeClass('disabled');
                    navigation.find('.arrow.right').removeClass('disabled');
                }
            } else if (direction === 'right') {
                newScrollLeft = Math.min(maxScrollLeft, currentScrollLeft + (itemWidth + 16));
                if ((currentScrollLeft / itemWidth) >= 0) {
                    bullets.removeClass('active');
                    bullets.eq(1).addClass('active');
                    navigation.find('.arrow.left').removeClass('disabled');
                    navigation.find('.arrow.right').removeClass('disabled');
                }

                if ((maxScrollLeft - currentScrollLeft) <= (itemWidth + 16)) {
                    bullets.removeClass('active');
                    bullets.eq(2).addClass('active');
                    navigation.find('.arrow.right').addClass('disabled');
                }
            }
        } else if (index === 0) {
            newScrollLeft = 0;
            bullets.removeClass('active');
            bullets.eq(0).addClass('active');
            navigation.find('.arrow.left').addClass('disabled');
            navigation.find('.arrow.right').removeClass('disabled');
        } else if (index === bullets.length - 1) {
            newScrollLeft = carousel[0].scrollWidth - carousel.width();
            bullets.removeClass('active');
            bullets.eq(bullets.length - 1).addClass('active');
            navigation.find('.arrow.left').removeClass('disabled');
            navigation.find('.arrow.right').addClass('disabled');
        } else {
            const itemsPerGroup = Math.floor(totalItems / visibleItems);
            const targetItem = Math.max(0, index * itemsPerGroup);
            newScrollLeft = Math.min(targetItem * (itemWidth + 16), carousel[0].scrollWidth - carousel.width());
            bullets.removeClass('active');
            bullets.eq(index).addClass('active');
            navigation.find('.arrow.left').removeClass('disabled');
            navigation.find('.arrow.right').removeClass('disabled');
        }

        carousel.animate({ scrollLeft: newScrollLeft }, 300);
    },
    getParamsStartWith: function(url) {
        return url.includes('?') ? '&' : '?';
    },
    search: {
        limit: (typeof carsPerPage !== 'undefined' ? carsPerPage : 40),
        paging: true,
        storagePrefix: (filter.serverSide ? 'filters_' : 'filterD_'),
        url: (filter.serverSide ? _d.url.search.results : _d.url.search.result) +  '/' + (typeof search_GUID !== 'undefined' ? search_GUID : ''),
        template: {
            filter: $('#tpl-filter').text(),
            carGroups: $('#tpl-car-groups').text(),
            showing: $('#tpl-showing').text(),
            sorting: $('#tpl-sorting').text(),
            filterApplied: $('#tpl-filters-applied').text(),
            cars: $('#tpl-cars').text(),
            filterAppliedBottom: $('#tpl-filters-applied-bottom').text()
        },
        target: {
            filter: $('#search-filter-body'),
            carGroups: $('#car-groups'),
            showing: $('#showing'),
            sorting: $('#sorting'),
            filterApplied: $('#filters-applied'),
            cars: $('#cars'),
            filterAppliedBottom: $('#filters-applied-bottom')
        },
        init: function() {
            if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                grecaptcha.enterprise.ready(function() {
                    $('.grecaptcha-badge').addClass('grecaptcha-badge-visible');
                });
            }

            if (listData !== false) {
                sp.search.parseData(listData, true);
            } else {
                const isReference = urlParser.init();
                const isPreviousSearchGUID = (typeof isReference.get !== 'undefined' && typeof isReference.get.refSearchGUID !== 'undefined' && typeof isReference.get.carId !== 'undefined');
                let getParams = {};
                let getQuery = '';

                if ((typeof fakeRedirect !== 'undefined' && fakeRedirect) || isPreviousSearchGUID) {

                    if (typeof isReference.get !== 'undefined') {
                        if (typeof isReference.get.ep !== 'undefined') {
                            getParams.ep = isReference.get.ep;
                        }

                        if (typeof isReference.get.exc_p !== 'undefined') {
                            getParams.exc_p = isReference.get.exc_p;
                        }

                        if (typeof isReference.get.exc_l !== 'undefined') {
                            getParams.exc_l = isReference.get.exc_l;
                        }
                    }

                    if (typeof isModification !== 'undefined' && isModification) {
                        getParams.mod = 1;
                    }

                    sp.search.url = (filter.serverSide ? _d.url.search.resultsForAggregator : _d.url.search.resultForAggregator);

                    if (!$.isEmptyObject(getParams)) {
                        getQuery = sp.getParamsStartWith(sp.search.url) + $.param(getParams);
                    }

                    sp.search.url = sp.search.url + getQuery;

                } else {

                    if (typeof isReference.get !== 'undefined') {
                        if (typeof isReference.get.exc_p !== 'undefined') {
                            getParams.exc_p = isReference.get.exc_p;
                        }

                        if (typeof isReference.get.exc_l !== 'undefined') {
                            getParams.exc_l = isReference.get.exc_l;
                        }
                    }

                    if (!$.isEmptyObject(getParams)) {
                        getQuery = sp.getParamsStartWith(sp.search.url) + $.param(getParams);
                        sp.search.url = sp.search.url + getQuery;
                    }
                }

                let storedFilters = {};
                let requestsType = 'GET';
                if (filter.serverSide) {
                    storedFilters = sp.getFilterParamsFromStorage();
                    requestsType = 'POST';
                }

                sp.search.request(storedFilters, requestsType);
            }
        },
        ctSlider: {
            index: 0,
            total: 0,
            totalVisible: 6,
            totalWidth: 0,
            handler: $('.car-top-filter-slider'),
            itemWidth: 142,
            init: function() {

                sp.search.ctSlider.total = $('.car-top-filter-item').length;
                sp.search.ctSlider.handler = $('.car-top-filter-slider');

                sp.search.ctSlider.totalWidth = (sp.search.ctSlider.total * sp.search.ctSlider.itemWidth) - 6;
                sp.search.ctSlider.handler.width(sp.search.ctSlider.totalWidth);

                sp.search.ctSlider.arrows();

                $('.car-top-filter-control').on('click', function() {
                    var that = $(this),
                        speed = 200;

                    if (that.hasClass('disabled')) {
                        return false;
                    }

                    that.addClass('disabled');

                    if (that.hasClass('prev')) {
                        sp.search.ctSlider.handler.animate({
                            left: sp.search.ctSlider.index === 1
                                ? 0
                                : '+=' + sp.search.ctSlider.itemWidth
                        }, speed, function() {
                            sp.search.ctSlider.index--;
                            sp.search.ctSlider.arrows();
                        });
                    } else if (that.hasClass('next')) {
                        let leftToAdd = sp.search.ctSlider.itemWidth;

                        const lastVisibleItemIdx = sp.search.ctSlider.index + sp.search.ctSlider.totalVisible;
                        const itemsTillLast = sp.search.ctSlider.total - (lastVisibleItemIdx + 1);

                        /* taking margin into account for the last slide */
                        if (itemsTillLast === 0) {
                            leftToAdd += 6;
                        }

                        sp.search.ctSlider.handler.animate({
                            left: '-=' + leftToAdd
                        }, speed, function() {
                            sp.search.ctSlider.index++;
                            sp.search.ctSlider.arrows();
                        });
                    }
                });
            },
            arrows: function() {
                const movedToLastItem = sp.isMovedToLastItem();

                const isRtl = window._d.isRTL;

                const nextControl = isRtl ? '.car-top-filter-control.prev' : '.car-top-filter-control.next';
                const prevControl = isRtl ? '.car-top-filter-control.next' : '.car-top-filter-control.prev';

                const atLastCar = movedToLastItem || (isRtl
                    ? sp.search.ctSlider.index <= -(sp.search.ctSlider.total - sp.search.ctSlider.totalVisible)
                    : sp.search.ctSlider.index === sp.search.ctSlider.total - sp.search.ctSlider.totalVisible);

                const atFirstCar = isRtl
                    ? sp.search.ctSlider.index >= 0
                    : sp.search.ctSlider.index === 0;

                $(nextControl).css('visibility', atLastCar ? 'hidden' : 'visible');
                $(prevControl).css('visibility', atFirstCar ? 'hidden' : 'visible');

                $('.car-top-filter-control').removeClass('disabled');
            }
        },
        request: function(postParams, requestType) {
            let defaultRequestType = 'GET';
            let defaultPostParams = {};

            if (typeof postParams !== 'undefined') {
                defaultPostParams = postParams;
            }

            if (typeof requestType !== 'undefined') {
                defaultRequestType = requestType;
            }

            if (typeof grecaptcha !== 'undefined' && grecaptcha.enterprise) {
                grecaptcha.enterprise.ready(function() {
                    grecaptcha.enterprise.execute('6LdtKsUpAAAAAJXl5SYQ4T2jvjPYds1giYvpjDIr', {action: 'search'})
                        .then((token) => {
                            defaultPostParams.gToken = token;
                        })
                        .catch(() => {
                            // For now, if something is wrong with recaptcha, proceed as normal
                        })
                        .then(() => {
                            $.ajax({
                                url: sp.search.url,
                                type: defaultRequestType,
                                data: defaultPostParams,
                                dataType: 'json',
                                success: function(response) {
                                    sp.search.parseData(response, true);
                                },
                                error: function() {
                                    sp.noResults();
                                }
                            });
                        });
                });
            } else {
                $.ajax({
                    url: sp.search.url,
                    type: defaultRequestType,
                    data: defaultPostParams,
                    dataType: 'json',
                    success: function(response) {
                        sp.search.parseData(response, true);
                    },
                    error: function() {
                        sp.noResults();
                    }
                });
            }
        },
        parseData: function(data, updateFilters) {
            sp.dataSnapshot = data;

            $('.grecaptcha-badge').removeClass('grecaptcha-badge-visible');

            sp.showSearchSurvey();

            $('.logo-search-parent').hide();
            $('.content-wrap').removeClass('hide');

            if (data.cnt > 0) {
                if (typeof data['filter']['mapLocations'] !== 'undefined' && data['filter']['mapLocations'].length > 0) {
                    $('.hirepoint-block').show();
                }

                var tempList;

                if ((typeof fakeRedirect !== 'undefined' && fakeRedirect) || offerNotFoundOrExpired > 0) {
                    for (var f = 0; f < data.list.length; f++) {
                        const { carInfoHash: selectedCarInfoHash } = typeof selectedCar !== 'undefined' ? selectedCar : {};
                        const isAlternative = typeof isAlternativeFlow !== 'undefined' ? isAlternativeFlow : false;

                        const car = data.list[f];
                        const { carInfoHash } = car;
                        const hash = selectedCarInfoHash;
                        const flag = isAlternative ? 'alternative' : 'selected';

                        if (hash === carInfoHash) {
                            car[flag] = true;
                            car.selected = true;
                            if (data.upsell && data.upsell.upsellCars) {
                                car.upsellCars = data.upsell.upsellCars;

                                car.upsellCars[0].upsellBlock = {
                                    showTitle: true,
                                    multi: data.upsell.multi,
                                    upsellPriceDifference: data.upsell.upsellPriceDifference
                                };

                                car.upsellCars.rentalPeriod = data.upsell.rentalPeriod;
                            }
                            tempList = car;
                            data.list[f].book_url = data.list[f].book_url.replace('notSelected=1', '');
                            data.list.splice(f, 1);
                            break;
                        }
                    }
                } else if (typeof viewedCars !== 'undefined') {
                    for (var j = 0; j < data.list.length; j++) {
                        for (var k = 0; k < viewedCars.length; k++) {
                            if (viewedCars[k].carInfoHash === data.list[j].carInfoHash) {
                                data.list[j].viewed = true;

                                if (viewedCars.length - 1 === k) {
                                    data.list[j].lastviewed = true;
                                }
                            }
                        }
                    }
                }

                if (typeof tempList !== 'undefined') {
                    data.list.unshift(tempList);
                }

                if (!filter.serverSide) {
                    if (sp.search.paging) {
                        for (var i = 0; i < data.list.length; i++) {
                            if (i >= sp.search.limit) {
                                data.list[i]['noShow'] = true;
                            }
                        }
                    }
                }

                const target = sp.search.target;
                const template = sp.search.template;

                target.showing.html(Mustache.render(template.showing, data));
                target.filter.html(Mustache.render(template.filter, data));
                target.carGroups.html(Mustache.render(template.carGroups, data));
                promoBanner.init();

                if (updateFilters) {
                    target.sorting.append(Mustache.render(template.sorting, data));
                    target.filterApplied.html(Mustache.render(template.filterApplied));
                    target.filterAppliedBottom.html(Mustache.render(template.filterAppliedBottom));

                    if (filter.serverSide) {
                        sp.updateFilterCheckboxState();
                        filter.removeAllFilters();
                    }
                }

                filter.init(data, updateFilters);

                if (data.append) {
                    target.cars.append(Mustache.render(template.cars, data));
                } else {
                    target.cars.html(Mustache.render(template.cars, data));
                }

                tooltip.init();

                //Display possible markers
                $('#open-hirepoints').on('click', function(e) {
                    e.preventDefault();

                    var backEndData = data['filter']['mapLocations'],
                        arrNeeded = [];

                    //Unset old properties
                    for (var j = 0; j < backEndData.length; j++) {
                        data['filter']['mapLocations'][j]['cars_available'] = [];
                        data['filter']['mapLocations'][j]['logo'] = [];
                        data['filter']['mapLocations'][j]['display'] = 0;
                        data['filter']['mapLocations'][j]['count_cars'] = 0;
                        data['filter']['mapLocations'][j]['min_price'] = 0;
                        data['filter']['mapLocations'][j]['previous_price'] = 0;
                    }

                    function populateWithData(i, obj) {
                        for (var j = 0; j < backEndData.length; j++) {

                            if (backEndData[j]['key'] === $(obj).data('map-locations')) {
                                data['filter']['mapLocations'][j]['cars_available'].push($(obj).data('total-price'));
                                data['filter']['mapLocations'][j]['count_cars'] = data['filter']['mapLocations'][j]['count_cars'] + 1;
                                data['filter']['mapLocations'][j]['display'] = 1;
                                var supLogo = $(obj).find('.supplier-block, .car-box-supplier-wrapper').children('.vcenter').children('img').data('src');

                                if (data['filter']['mapLocations'][j]['logo'].indexOf(supLogo) === -1) {
                                    data['filter']['mapLocations'][j]['logo'].push(supLogo);
                                }

                                if (data['filter']['mapLocations'][j]['previous_price'] === 0) {
                                    data['filter']['mapLocations'][j]['min_price'] =  $(obj).data('total-price');
                                    data['filter']['mapLocations'][j]['previous_price'] = $(obj).data('total-price');
                                    data['filter']['mapLocations'][j]['price_formatted'] = $(obj).data('price-formatted');
                                } else if (parseFloat($(obj).data('total-price')) < data['filter']['mapLocations'][j]['min_price']) {
                                    data['filter']['mapLocations'][j]['min_price'] =  $(obj).data('total-price');
                                    data['filter']['mapLocations'][j]['previous_price'] = data['filter']['mapLocations'][j]['min_price'];
                                    data['filter']['mapLocations'][j]['price_formatted'] = $(obj).data('price-formatted');
                                } else {
                                    data['filter']['mapLocations'][j]['previous_price'] =  $(obj).data('total-price');
                                }
                            }
                        }
                    }

                    if ($('#car-box-container').find('.filtered').length !== 0) {
                        $('.filtered').each(function(i, obj) {
                            populateWithData(i, obj);
                        });
                    } else {
                        $('.car-box').each(function(i, obj) {
                            populateWithData(i, obj);
                        });
                    }


                    //get clear markers array
                    for (var k = 0; k < backEndData.length; k++) {
                        if (backEndData[k]['display'] === 1 && backEndData[k]['key'] !== '0_0000_0_0000') {
                            arrNeeded.push(data['filter']['mapLocations'][k]);
                        }
                    }

                    //initiate the map
                    var hirepointsLocs = [],
                        minPrices = [],
                        logosArr = [],
                        addressArr = [],
                        countArr = [];

                    $.each(arrNeeded, function(key) {
                        var logosTemp = [];
                        hirepointsLocs.push([arrNeeded[key]['lat'], arrNeeded[key]['lng']]);
                        minPrices.push(arrNeeded[key]['price_formatted']);
                        $.each(arrNeeded[key]['logo'], function(key2) {
                            logosTemp.push('<img class="leaflet-popup-supplier-logo" src="' + arrNeeded[key]['logo'][key2] + '">');
                        });
                        logosArr.push(logosTemp);
                        addressArr.push(arrNeeded[key]['pick_address']);
                        countArr.push(arrNeeded[key]['count_cars']);
                    });
                    var mmMap = {
                        locations: hirepointsLocs,
                        arrayOfMarkers: [],
                        init: function() {
                            $('#hirepoints-map-placeholder').append('<div id="hirepoints-map"><div id="close-hirepoints-map"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 7.3783L1.66376 11.7145C1.28315 12.0952 0.666063 12.0952 0.285455 11.7145C-0.0951518 11.3339 -0.0951518 10.7169 0.285455 10.3362L4.6217 6L0.285455 1.66376C-0.0951518 1.28315 -0.0951518 0.666063 0.285455 0.285455C0.666063 -0.0951518 1.28315 -0.0951518 1.66376 0.285455L6 4.6217L10.3362 0.285455C10.7169 -0.0951518 11.3339 -0.0951518 11.7145 0.285455C12.0952 0.666063 12.0952 1.28315 11.7145 1.66376L7.3783 6L11.7145 10.3362C12.0952 10.7169 12.0952 11.3339 11.7145 11.7145C11.3339 12.0952 10.7169 12.0952 10.3362 11.7145L6 7.3783Z" fill="#757575"></svg></div></div>');

                            if ($('#hirepoints-map').is(':hidden')) {
                                $('#hirepoints-map').show();
                            } else {
                                $('#hirepoints-map').css('z-index', '9999');
                            }

                            var LMap = L.map('hirepoints-map');
                            LMap.zoomControl.setPosition('bottomright');
                            L.tileLayer('https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png', {
                                attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank">CARTO</a>'
                            }).addTo(LMap);
                            LMap.invalidateSize();
                            mmMap.setMarkers(LMap, mmMap.locations);
                            mmMap.setZoom(LMap, mmMap.locations);
                        },
                        setMarkers: function(map, markers) {

                            var clusterMarkers = L.markerClusterGroup();

                            for (var i = 0; i < markers.length; i++) {
                                var logosStr = logosArr[i].join(''),
                                    airportIATA = arrNeeded[i]['defaultName'],
                                    priceFrom = _d.t.priceFrom,
                                    showXOffers = _d.t.showXOffers;

                                var strLength = minPrices[i].length,
                                    centerAligner = 0;

                                if (airportIATA !== 'Non-Airport') {
                                    switch (strLength) {
                                        case 10:
                                            centerAligner = 45;
                                            break;
                                        case 9:
                                            centerAligner = 32;
                                            break;
                                        case 8:
                                            centerAligner = 25;
                                            break;
                                        case 7:
                                            centerAligner = 25;
                                            break;
                                        case 5:
                                        default:
                                            centerAligner = 18;
                                            break;
                                    }
                                } else {
                                    switch (strLength) {
                                        case 10:
                                            centerAligner = 50;
                                            break;
                                        case 9:
                                            centerAligner = 28;
                                            break;
                                        case 8:
                                            centerAligner = 6;
                                            break;
                                        case 7:
                                            centerAligner = 3;
                                            break;
                                        case 5:
                                        default:
                                            centerAligner = -3;
                                            break;
                                    }
                                }
                                clusterMarkers.addLayer(L.marker([markers[i][0], markers[i][1]],
                                    {
                                        icon: L.icon({
                                            iconUrl: _d.url.bh + '/image/get-discover-markers/' + minPrices[i] + '/' + airportIATA + '/' + strLength,
                                            popupAnchor: [centerAligner, 0]
                                        })
                                    }).bindPopup('<div class="leaflet-popup-title">' + priceFrom.replace('{{min}}', minPrices[i]) + '</div><div class="sup-logo-parent"><div class="sup-logo-container">' + logosStr +
                                    '</div></div><div class="location-addr-parent"><div class="location-addr-icon"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                    '<path fill-rule="evenodd" clip-rule="evenodd" d="M4 7.79457C4 4.59944 6.59944 2 9.7946 2C12.9897 2 15.5891 4.59944 15.5892 7.79457C15.5892 11.7598 10.4036 17.5811 10.1828 17.8269C9.97582 18.0575 9.61376 18.0579 9.40638 17.8269C9.1856 17.5811 4 11.7598 4 7.79457ZM6.87924 7.79457C6.87924 9.40214 8.18705 10.71 9.79461 10.71C11.4021 10.71 12.71 9.40217 12.71 7.7946C12.71 6.18704 11.4021 4.87919 9.79461 4.87919C8.18708 4.87919 6.87924 6.18701 6.87924 7.79457Z" fill="#333333"/>\n' +
                                    '</svg></div><div class="leaflet-popup-address">' + addressArr[i] + '</div></div><div class="leaflet-popup-button trigger-map-location trigger-gtm-show-x-cars-click" data-key="' + arrNeeded[i]['key'] + '">' + showXOffers.replace('{amount}', countArr[i]) + '</div>'));
                                map.addLayer(clusterMarkers);
                                mmMap.arrayOfMarkers.push([markers[i][0], markers[i][1]]);
                            }
                        },
                        setZoom: function(map) {
                            var bounds = new L.LatLngBounds(mmMap.arrayOfMarkers);
                            map.fitBounds(bounds.pad(0.05));
                        }
                    };

                    //remove old map
                    $('#hirepoints-map').remove();
                    mmMap.init();

                    $('#close-hirepoints-map').on('click', function(e) {
                        e.preventDefault();
                        $('#hirepoints-map').hide();
                    });

                    $('body').one('click', '.trigger-map-location', function() {
                        $('.remove-all-filters').hide();

                        if (!$('#map-locations-'+ $(this).data('key')).is(':checked')) {
                            $('.filter-map-locations[data-value="'+$(this).data('key')+'"]').trigger('click');
                        }
                        $('#hirepoints-map').hide();
                    }).on('click', '.leaflet-marker-icon', function(e) {
                        e.preventDefault();
                        $('.leaflet-marker-icon').removeClass('marker-clicked');
                        $(this).addClass('marker-clicked');
                    });
                });

                const promo = $('#tpl-promo, #tpl-promo-referral');
                if (promo.length > 0 && $('.home-promo').length === 0) {
                    $('.search-result-set').prepend(Mustache.render(promo.text()));
                }

                if (fcBanner && $('.fc-box').length === 0) {
                    $('.car-box:first').after(Mustache.render($('#tpl-fc').text(), data));
                }

                if (!filter.serverSide) {
                    sp.updateFilterCheckboxState();
                }

                if ($('.car-box.viewed').length > 0) {
                    var lastViewed = ($('.car-box.last-viewed').length > 0 ? $('.car-box.last-viewed') : $('.car-box.viewed:last'));
                    $('html, body').animate({
                        scrollTop: lastViewed.offset().top
                    }, 800);
                }

                var otherCarElement = $('.other-cars');

                if (otherCarElement.length > 0) {
                    var otherCarText = otherCarElement.html();
                    otherCarElement.html(otherCarText.replace('#car_count#', data.cnt - 1));

                    if ($('.car-box:visible').length === 1) {
                        otherCarElement.hide();
                    }
                }

                (() => new LazyLoad())();

                sp.ga(data);
                sp.search.ctSlider.init();

                if (filter.serverSide) {
                    filter.filterGroupUpdates();
                    filter.carGroupsUpdates();
                    filter.removeAllFilters();
                }

                setTimeout(() => {
                    const isReference = urlParser.init();
                    if (isReference && typeof isReference.get !== 'undefined' && typeof isReference.get.cug !== 'undefined') {
                        const checkbox = $('input[type="checkbox"][value="cug"]');
                        if (!checkbox.is(':checked')) {
                            checkbox.trigger('click');
                        }
                    }
                }, 200);

                if (typeof abTest485 !== 'undefined' && abTest485 === 1) {
                    ['exceptional', 'excellent', 'very-good'].forEach(rating => {
                        const element = $(`#rating-${rating}-true`);
                        if (element.length) {
                            const intervalId = setInterval(() => {
                                if (element.prop('checked')) {
                                    clearInterval(intervalId);
                                } else {
                                    element.trigger('click');
                                }
                            }, 100);
                        }
                    });
                }
            } else {
                sp.noResults();
            }
        }
    },
    getFilterParamsFromStorage: function() {
        const filterData = storage.get(sp.search.storagePrefix + searchHash);
        let result = {};

        if (filterData) {
            for (let key in filterData) {
                if (Object.prototype.hasOwnProperty.call(filterData, key)) {
                    if (filterData[key].name === 'firstCategory' && filterData[key].value !== 'none') {
                        filter.filteredCategories.push(filterData[key].value);
                    }
                }
            }

            result = JSON.parse(JSON.stringify(filterData));
        }

        return result;
    },
    updateFilterCheckboxState: function() {
        const filterData = storage.get(sp.search.storagePrefix + searchHash);

        if (filterData) {

            sp.updateStorageData(filterData);

            for (const key in filterData) {
                if (Object.prototype.hasOwnProperty.call(filterData, key)) {
                    $('.my-checkbox', '#search-filter').each(function() {
                        const that = $(this);
                        const category = that.data('category');
                        const inputName = that.attr('name');
                        const inputValue = that.val();

                        if (filterData[key].name === inputName && (filterData[key].value === inputValue)) {
                            if (!filter.serverSide) {
                                setTimeout(function() {
                                    if (inputName.indexOf('car-groups') >= 0) {
                                        $('.car-groups-item[data-id=' + inputName + ']').trigger('click');
                                    } else {
                                        that.next().trigger('click');
                                    }
                                }, 100);
                            } else {
                                $('.filter-list').append('<a href="" class="remove-filter" data-category="' + category + '" data-value="' + inputValue + '">' + that.next().data('text') + '</a>');
                                $('.filters-applied').css('display', 'flex');
                            }
                        }
                    });
                }
            }
        }
    },
    countDisplayedCars: function() {
        sp.resetRenderedProductBatch();
        let count = 0;
        $('.car-box').each(function() {
            const that = $(this);
            if (that.is(':visible')) {
                sp.renderedProductBatch.push(
                    {
                        supplier: that.data('supplier'),
                        c_id: that.data('car-id').toString()
                    }
                );
                count++;
            }
        });
        return count;
    },
    resetRenderedProductBatch: function() {
        sp.renderedProductBatch = [];
    },
    resetCurrentImpressionViews: function() {
        sp.currentImpressionViews = 0;
    },
    updateCurrentImpressionViews: function(amount) {
        sp.currentImpressionViews = amount;
    },
    splitIntoBatches: function(productAmount) {
        let ranges = [];
        for (let i = sp.currentImpressionViews; i <= productAmount; i += sp.impressionViewDefaultBatch) {
          let rangeStart = i,
              rangeEnd = Math.min(i + sp.impressionViewDefaultBatch, productAmount),
              range = [rangeStart, rangeEnd];
          ranges.push(range);
        }
        return ranges;
    },
    getProductBatch: function(range) {
        let productBatch = [];

        for (let s = range[0]; s < range[1]; s++) {
            let data = sp.renderedProductBatch[s];
            let carParams = sp.dataSnapshot.list.find(item => item.supplier.key === data.supplier && item.c_id === data.c_id);
            let product = {
                id: carParams.sipp,
                name: carParams.name,
                brand: carParams.supplier.name,
                category: myDataLayer.category,
                variant: '',
                list: 'Search results',
                position: carParams.idx
            };
            productBatch.push(product);
        }

        return productBatch;
    },
    noResults: function() {
        $('.logo-search-parent, .cug-banner, #search-filter-body').remove();
        $('.content-wrap, #load-data-no-result').show();
        $('.show-more-cars').hide();
        promoBanner.hide();
        if (typeof abTest470 !== 'undefined' && abTest470 === 1) {
            $('#filters-title').remove();
            $('.search-result-set').removeClass('col-9').addClass('col-12');
        }
        if ($('.track-prices').length) {
            $('.track-prices').remove();
        }

        document.title = _d.t.noCars;

        dataLayer.push({
            'searchResults': {
                'carCount': 0,
                'partnerCount': 0
            },
            'event': 'searchResults'
        });
    },
    sortBy: function() {

        dcUiDropDown.init();

        $(document).on('click', '.sort-by-list', function(e) {
            var that = $(this),
                sortType = that.data('type'),
                carBox = $('#car-box-container');

            e.preventDefault();

            carBox.addClass('loading');

            $('.sort-by-list').removeClass('active');
            that.addClass('active');

            setTimeout(function() {
                sp.orderBy(sortType, carBox, true, false);
            }, 200);
        });

        $(document).on('click', '.sorting-box-item', function() {
            const that = $(this);
            let sortType = that.data('type');
            let sortLabel = that.data('label');
            let eventName = that.data('event');
            let carBox = $('#car-box-container');

            if (that.hasClass('active')) {
                return false;
            }

            carBox.addClass('loading');
            $('.sorting-box-item').removeClass('active');
            that.addClass('active');
            $('.car-box').removeClass('selected-car-box mb-initial');
            $('.your-selected-car').remove();

            $.ajax({
                url: _d.url.optimizelyEvent,
                type: 'POST',
                data: {
                    eventName: eventName
                }
            });

            setTimeout(function() {
                sp.orderBy(sortType, carBox, true, sortLabel);
            }, 200);
        });
    },
    orderBy: function(sortType, carBoxContainer, updateFilter, sortLabel) {
        $('#sortBy').val(sortType);
        const sortLabelElement = '<div class="your-selected-car">' + sortLabel +'</div>';

        if (filter.serverSide) {
            filter.resetPaging();
            filter.formData();
            if (updateFilter) {
                filter.filterRequest();
            }

        } else {
            switch (sortType) {
                case 'value':
                    carBoxContainer.find('.car-box').sort(function(a, b) {
                        return b.getAttribute('data-selected') - a.getAttribute('data-selected') || b.getAttribute('data-sort-by-value') - a.getAttribute('data-sort-by-value');
                    }).prependTo(carBoxContainer);
                    if (sortLabel) {
                        sp.highlightFirstCarBox(carBoxContainer, sortLabelElement);
                    }
                    break;
                case 'rating':
                    carBoxContainer.find('.car-box').sort(function(a, b) {
                        return b.getAttribute('data-selected') - a.getAttribute('data-selected') || b.getAttribute('data-sort-by-rating') - a.getAttribute('data-sort-by-rating');
                    }).prependTo(carBoxContainer);
                    if (sortLabel) {
                        sp.highlightFirstCarBox(carBoxContainer, sortLabelElement);
                    }
                    break;
                case 'cheapest':
                default:
                    carBoxContainer.find('.car-box').sort(function(a, b) {
                        return b.getAttribute('data-selected') - a.getAttribute('data-selected') || a.getAttribute('data-total-price') - b.getAttribute('data-total-price');
                    }).prependTo(carBoxContainer);
                    if (sortLabel) {
                        sp.highlightFirstCarBox(carBoxContainer, sortLabelElement);
                    }
                    break;
            }

            if (updateFilter) {
                filter.update();
            }
            carBoxContainer.removeClass('loading');
        }
    },
    highlightFirstCarBox: function(carBoxContainer, sortLabelElement) {
        const box = carBoxContainer.find('.car-box').first();

        if (box.find('.your-selected-car').length === 0) {
            box.prepend(sortLabelElement);
        } else {
            box.find('.your-selected-car').remove();
            box.prepend(sortLabelElement);
        }
        box.addClass('selected-car-box mb-initial');
    },
    ga: function(data) {
        try {
            window.dataLayer.push(
                {
                    'event': 'searchResults',
                    'searchResults': {
                        'carCount': data.cnt,
                        'partnerCount': data.filter.supplier.length
                    },
                    'search_data': {
                        'title': 'Search Results',
                        'page': '/search-result?' + gaQuery,
                        'data': gaEvent
                    }
                }
            );

            if (!data.append) {
                sp.resetCurrentImpressionViews();
            }
            let displayedCars = sp.countDisplayedCars();
            let productBatches = sp.splitIntoBatches(displayedCars);
            sp.updateCurrentImpressionViews(displayedCars);

            productBatches.forEach(function(productBatch) {
                let eventData = sp.getProductBatch(productBatch);
                if (eventData.length) {
                    if (filter.filteredCategories.length) {
                        myDataLayer.sendImpressionEvent(eventData, 'impressionFilter');
                    } else {
                        myDataLayer.sendImpressionEvent(eventData, 'impressionView');
                    }
                }
            });

        } catch (err) {}
    },
    updateStorageData: function(data) {
        const removeOldLocalStorage = []; // Array to hold the keys
        // Iterate over localStorage and insert the keys that meet the condition into arr
        for (let l = 0; l < localStorage.length; l++) {
            if (localStorage.key(l).substring(0, 8) === sp.search.storagePrefix) {
                removeOldLocalStorage.push(localStorage.key(l));
            }
        }

        // Iterate over arr and remove the items by key
        for (let r = 0; r < removeOldLocalStorage.length; r++) {
            localStorage.removeItem(removeOldLocalStorage[r]);
        }

        storage.save(sp.search.storagePrefix + searchHash, data);
    },
    isMovedToLastItem: function() {
        return ($('.car-top-filter-container').width() > 800 ?
                sp.search.ctSlider.index >= sp.search.ctSlider.total - sp.search.ctSlider.totalVisible :
                sp.search.ctSlider.index > sp.search.ctSlider.total - sp.search.ctSlider.totalVisible
        );
    }
};
